/**
 * 异常车辆记录
 */
import React, { useEffect, useState, useMemo } from "react";
import { Card, Form, Row, Col, Button, Input, Select, Popconfirm, Modal, message, Image } from "antd";
import dayjs from "dayjs";
import CommonTable from "@/components/commonTable";
import ExportButton from "@/components/exportButton";
import { useTable } from "@/utils/useTable";
import {
  deleteExceptionRecordRequest,
  editExceptionRequest,
  exceptionRecordListRequest,
} from "@/service/underwritingRecord";
import styles from "@/styles/pageContent.module.scss";
import DatePicker from "@/components/datePicker";
import PermissionButton from "@/components/permissionButton";
import RenderEllipsisColumn from "@/components/renderEllipsisColumn";
import { insureListRequest } from "@/service/insurerManage";
import { channelListRequest } from "@/service/channelRecode";
import { companyListRequest } from "@/service/companyManage";
import { useDispatch } from "react-redux";
import Thumbnail from "@/components/thumbnail";
import { getAllErrCode } from "@/service/exceptionRecord";
import { setAebParamsRequest } from "@/service/parameterConfiguration";
import { title } from "process";
import CategoryTreeSelect from "@/components/categoryTreeSelect";
import { useUserCateIdArr } from "@/utils/ownHooks";
import { log } from "console";
import { cateNodeHandlerGen } from "@/utils/cate";
import { deviceTypeData } from "@/constants/deviceManage";

const ExceptionRecord = () => {
  const cateIdArr = useUserCateIdArr();

  //分组CateId处理
  const [cateIdHandler, setCateIdHandler] = useState<((ids: number[]) => number[]) | null>(null);

  useEffect(() => {
    const initHandler = async () => {
      const handler = await cateNodeHandlerGen();
      setCateIdHandler(() => handler);
    };
    initHandler();
  }, []);
  const [commercialCompany, setCommercialCompany] = useState<any>([]); // 承保保司
  const [searchParams, setSearchParams] = useState({
    startDate: `${dayjs().subtract(7, "day").format("YYYY-MM-DD")}`,
    endDate: `${dayjs().format("YYYY-MM-DD")}`,
    cateId: cateIdArr,
  }); // 搜索相关的参数
  const [form] = Form.useForm();
  const [editMarkForm] = Form.useForm();
  const { page, limit, loading, data, totalCount, onPageChange, getData, setData } =
    useTable({
      requestFunc: exceptionRecordListRequest,
      initRequest: true,
      initPageSize: 40,
      searchParams,
    });
  const { RangePicker } = DatePicker;
  const [carBusinessUnit, setCarBusinessUnit] = useState([]); // 获取业务渠道
  const [allCompany, setAllCompany] = useState<any>([]); // 车队选择
  const [editMarkVisible, setEditMarkVisible] = useState(false)
  const dispatch = useDispatch();
  const [allErrCode, setAllErrCode] = useState<any>([]); // 故障名称

  const updateAllErrCode = async () => {
    try {
      const res = await getAllErrCode()
      const resData = res.data?.data || [];
      setAllErrCode(resData.map((item: any) => {
        return {
          label: item.first,
          value: item.second
        }
      }));


    } catch (e) {
      message.error('获取故障名称失败')
      setAllErrCode([])
    }
  }

  useEffect(() => {
    getCommercialCompany()
    getBusinessUnitType()
    getCateAllCompanyData()
    updateAllErrCode()
  }, [])

  const editMarkOK = () => {
    const values = editMarkForm.getFieldsValue()
    editExceptionRequest(values).then((res) => {
      if (res.data.code == 0) {
        message.success('保存成功！')
        setEditMarkVisible(false)
        getData()
      }
    })
  }

  const editMarkFn = (item: any) => {
    console.log(item, 'itemmmmmmm')
    editMarkForm.setFieldsValue({ remark: item.remark, id: item.id })
    setEditMarkVisible(true)
  }

  // 审核函数 - 占位函数，后续补全
  const handleAudit = async (item: any) => {
    console.log('审核项目:', item);

    try {
      await deleteExceptionRecordRequest(item.id);
      message.success('审核成功！');
    }
    catch (error) {
      message.error('审核失败！');
    } finally {

      getData(); // 刷新数据
    }


  }

  // 获取车队
  const getCateAllCompanyData = async () => {
    const res = await companyListRequest({ page: 1, limit: 20000, name: "" });
    const data = res.data?.data || [];
    //循环遍历data
    const aa: any = [];
    data.forEach((item: any) => {
      aa.push({ label: item.name, value: item.id });
    });
    setAllCompany(aa);
  };

  // 获取业务渠道
  const getBusinessUnitType = async () => {
    // const res = await tagListRequest({
    //   tagSorts: [TagCategoryEnum.businessUnit],
    // });
    const res = await channelListRequest({ page: 1, limit: 50000, name: '' });
    const tags: any = [];
    (res.data?.data || []).forEach((item: any) => {
      const { name, id } = item;
      tags.push({ label: name, value: id });
    });
    setCarBusinessUnit(tags);
  }

  const getCommercialCompany = async () => {
    const res = await insureListRequest('');
    const tags: any = [];
    (res.data?.data || []).forEach((item: any) => {
      const { name, id } = item;
      tags.push({ label: name, value: id });
    });
    setCommercialCompany(tags);
  }

  // 处理搜索参数
  const operateSearchParams = (params: any, isExport?: boolean) => {
    // console.log(params, 'oldParams')
    const newParams = { ...params };
    newParams.startDate = dayjs(params.day[0]).format("YYYY-MM-DD");
    newParams.endDate = dayjs(params.day[1]).format("YYYY-MM-DD");
    delete newParams.day;
    if (newParams.cateId && cateIdHandler) {
      newParams.cateId = cateIdHandler(newParams.cateId);
    }
    if (!newParams.plateNumber) {
      delete newParams.plateNumber
    }
    if (!isExport) {
      setSearchParams(newParams);
    }

    if (isExport) {
      newParams.export = true;
    }

    console.log(newParams, 'newParams')
    return newParams;
  };

  // 获取导出的参数
  const getExportParams = () => {
    const values = form.getFieldsValue();
    return operateSearchParams(values, true);
  };

  // 搜索
  const onSearch = async (values: any) => {
    const newSearchParams = operateSearchParams(values);
    setSearchParams(newSearchParams);
  };

  // 点击表格日期跳转到驾驶行为分析页面
  const onCarClick = (plateNumber: string, date: string) => {
    dispatch({
      type: 'addTab',
      payload: {
        tab: '车辆诊断',
        key: '/car-admin/car-diagnosis',
        params: { plateNumber, beginDate: date, endDate: date }
      }
    })
  }

  // 表格列显示
  const columns = [
    {
      title: "问题来源",
      dataIndex: "type",
      width: 110,
      render: (value: string) => value ? <RenderEllipsisColumn ellipsis={true} text={value} /> : ''
    },
    {
      title: "车牌号",
      dataIndex: "plateNumber",
      width: 110,
      render: (value: string, item: any) => {
        return <Button type="link" onClick={() => {
          onCarClick(item.plateNumber, item.day)
        }}>{value}</Button>
      }
    },
    {
      title: "车架号",
      dataIndex: "frameNumber",
      width: 110,
      render: (value: string) => value ? <RenderEllipsisColumn ellipsis={true} text={value} /> : ''
    },
    {
      title: "统计日期",
      dataIndex: "day",
      width: 110,
      render: (value: string) => value ? <RenderEllipsisColumn ellipsis={true} text={value} /> : ''
    },
    {
      title: "服务状态",
      dataIndex: "serviceState",
      width: 110,
      render: (value: string) => value ? <RenderEllipsisColumn ellipsis={true} text={value} /> : ''
    },
    {
      title: "故障名称",
      dataIndex: "errorInfo",
      width: 110,
      render: (value: string) => value ? <RenderEllipsisColumn ellipsis={true} text={value} /> : ''
    },
    {
      title: "故障/风险存在天数",
      dataIndex: "maxDays",
      width: 110,
      render: (value: string) => <RenderEllipsisColumn ellipsis={true} text={value} />
    },
    {
      title: "AEB离线天数",
      dataIndex: "aebOfflineDays",
      width: 110,
      render: (value: string) => <RenderEllipsisColumn ellipsis={true} text={value} />
    },
    {
      title: "ADAS离线天数",
      dataIndex: "adasOfflineDays",
      width: 110,
      render: (value: string) => <RenderEllipsisColumn ellipsis={true} text={value} />
    },
    {
      title: "保司",
      dataIndex: "insurance",
      width: 110,
      render: (value: string) => value ? <RenderEllipsisColumn ellipsis={true} text={value} /> : ''
    },
    {
      title: "渠道",
      dataIndex: "channel",
      width: 110,
      render: (value: string) => value ? <RenderEllipsisColumn ellipsis={true} text={value} /> : ''
    },
    {
      title: "车队",
      dataIndex: "company",
      width: 110,
      render: (value: string) => {
        return <RenderEllipsisColumn ellipsis={true} text={value} />
      }
    },
    {
      title: "司机联系方式",
      dataIndex: "driverTel",
      width: 110,
      render: (value: string) => value ? <RenderEllipsisColumn ellipsis={true} text={value} /> : ''
    },
    {
      title: "车辆负责人联系方式",
      dataIndex: "manageTel",
      width: 110,
      render: (value: string) => value ? <RenderEllipsisColumn ellipsis={true} text={value} /> : ''
    },
    {
      title: "备注",
      dataIndex: "remark",
      width: 110,
      render: (value: string) => value ? <RenderEllipsisColumn ellipsis={true} text={value} /> : ''
    },

    {
      title: "DMS图片",
      dataIndex: "dmsImgUrl",
      width: 110,
      render: (value: any) => {
        return value ? <Image src={value} alt="DMS图片" width="100%" /> : null;
      },
    },
    {
      title: "ADAS图片",
      dataIndex: "adasImgUrl",
      width: 110,
      render: (value: any) => {
        return value ? <Image src={value} alt="ADAS图片" width="100%" /> : null;
      },
    }, {
      title: "BSD图片",
      dataIndex: "bsdImgUrl",
      width: 110,
      render: (value: any) => {
        return value ? <Image src={value} alt="BSD图片" width="100%" /> : null;
      },
    },
    {
      title: "是否审核",
      dataIndex: "deleteFlag",
      width: 110,
      render: (value: number) => {
        if (value === undefined || value === null) {
          return '--';
        }
        return value === 1 ? '是' : '否';
      }
    },
    {
      title: "系统复核结果",
      dataIndex: "review",
      width: 110,
      render: (value: number) => {
        if (value === undefined || value === null) {
          return '--';
        }
        const reviewMap: { [key: number]: string } = {
          1: '属实',
          0: '不属实',
          2: '不确定'
        };
        return <RenderEllipsisColumn ellipsis={true} text={reviewMap[value] || '--'} />;
      }
    },
    {
      ellipsis: { showTitle: false },
      title: "操作",
      dataIndex: "operate",
      width: 110,
      render: (_: string, item: any) => {
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Button type="link" onClick={() => {
              editMarkFn(item)
            }}>编辑备注</Button>
            {item.deleteFlag === 0 && (
              <Popconfirm
                title="是否将当前数据设置为已审核?"
                onConfirm={() => handleAudit(item)}
                okText="确认"
                cancelText="取消"
              >
                <Button type="link">审核</Button>
              </Popconfirm>
            )}

          </div>
        );
      },
    },

  ];



  return (
    <Card bordered={false} className={styles.fixPageContentBox}>
      <Form form={form} onFinish={onSearch} layout="vertical" autoComplete="off" initialValues={{
        day: [
          dayjs(`${dayjs().subtract(7, "day").format("YYYY-MM-DD")}`),
          dayjs(`${dayjs().format("YYYY-MM-DD")}`),
        ],
        deleteFlag: 0
      }}>
        <Row gutter={24}>
          <Col span={4}>
            <Form.Item label="车牌号" name="plateNumber">
              <Input placeholder="请输入车牌号" allowClear />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="问题来源"
              name="type"
            >
              <Select options={[{ label: '问题车', value: '问题车' }, { label: '风险车', value: '风险车' }, {
                label: '离线车',
                value: '离线车'
              }]}></Select>
            </Form.Item>
          </Col>
          {/* <Col span={4}>
            <Form.Item label="承保保司" name="insuranceIds">
              <Select
                placeholder="请选择承保保司"
                options={commercialCompany}
                allowClear
                showArrow
                showSearch
                optionFilterProp="label"
                mode="multiple"

              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="渠道" name="channelIds">
              <Select placeholder="请选择所属业务渠道" options={carBusinessUnit} allowClear showArrow showSearch
                optionFilterProp="label" mode="multiple" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="车队选择" name="companyIds">
              <Select
                mode="multiple"
                showSearch
                placeholder="请选择"
                style={{ width: "100%" }}
                options={allCompany}
                allowClear
                filterOption={(input, option) => {
                  const label = (option?.label || "") as string;
                  return label.indexOf(input.toLowerCase()) >= 0;
                }}
              />
            </Form.Item></Col> */}
          <Col span={4}>
            <Form.Item label="分类选择" name="cateId" initialValue={cateIdArr}>
              <CategoryTreeSelect treeCheckable />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="故障名称" name="codes">
              <Select mode="multiple" options={allErrCode} allowClear showArrow style={{ width: "100%" }}
                placeholder={'请选择故障名称'}></Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="是否审核" name="deleteFlag">
              <Select
                placeholder="请选择是否审核"
                allowClear
                showArrow
                options={[
                  { label: '是', value: 1 },
                  { label: '否', value: 0 }
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="时间范围"
              name="day"
            >
              <RangePicker allowClear={false} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="设备类型" name="deviceType">
              <Select placeholder="请选择设备类型" mode="multiple" options={deviceTypeData} allowClear showArrow showSearch optionFilterProp="label" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="系统复核结果" name="review">
              <Select
                placeholder="请选择系统复核结果"
                allowClear
                showArrow
                options={[
                  { label: '属实', value: 1 },
                  { label: '不属实', value: 0 },
                  { label: '不确定', value: 2 }
                ]}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="&nbsp;">
              <div className={styles.searchBox}>
                <Button
                  type="primary"
                  htmlType="submit"
                >
                  搜索
                </Button>
                <ExportButton
                  url={'api/v2/car/abnormal/list'}
                  fileName="异常车辆记录"
                  getParamsFunc={getExportParams}
                  requestMethod="GET"
                  permissionKey=""
                />
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <CommonTable
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange,
        }}
        bordered
        loading={loading}
      />
      <Modal title="编辑备注" open={editMarkVisible} onOk={editMarkOK} onCancel={() => {
        setEditMarkVisible(false)
      }}>
        <Form form={editMarkForm}>
          <Form.Item label="备注" name={'id'} hidden>
            <Input></Input>
          </Form.Item>
          <Form.Item label="备注" name={'remark'}>
            <Input.TextArea></Input.TextArea>
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

export default ExceptionRecord;
